import { render, staticRenderFns } from "./OpenCard.vue?vue&type=template&id=a27ee244&scoped=true"
import script from "./OpenCard.vue?vue&type=script&lang=js"
export * from "./OpenCard.vue?vue&type=script&lang=js"
import style0 from "./OpenCard.vue?vue&type=style&index=0&id=a27ee244&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27ee244",
  null
  
)

export default component.exports